import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Items16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M4 4.75H12V3.25H4V4.75Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.5714 7.25C14.2023 7.25 14.75 6.74744 14.75 6.08333V1.91667C14.75 1.25256 14.2023 0.75 13.5714 0.75H2.42857C1.79772 0.75 1.25 1.25256 1.25 1.91667V6.08333C1.25 6.74744 1.79772 7.25 2.42857 7.25H13.5714ZM13.25 2.25V5.75H2.75V2.25H13.25Z'
      fill='currentColor'
    />
    <path
      d='M4.5 13C5.05228 13 5.5 12.5523 5.5 12C5.5 11.4477 5.05228 11 4.5 11C3.94772 11 3.5 11.4477 3.5 12C3.5 12.5523 3.94772 13 4.5 13Z'
      fill='currentColor'
    />
    <path
      d='M9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z'
      fill='currentColor'
    />
    <path
      d='M11.5 13C12.0523 13 12.5 12.5523 12.5 12C12.5 11.4477 12.0523 11 11.5 11C10.9477 11 10.5 11.4477 10.5 12C10.5 12.5523 10.9477 13 11.5 13Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.5714 15.25C14.2023 15.25 14.75 14.7474 14.75 14.0833V9.91667C14.75 9.25256 14.2023 8.75 13.5714 8.75H2.42857C1.79772 8.75 1.25 9.25256 1.25 9.91667V14.0833C1.25 14.7474 1.79772 15.25 2.42857 15.25H13.5714ZM13.25 10.25V13.75H2.75V10.25H13.25Z'
      fill='currentColor'
    />
  </Svg>
);

Items16.displayName = 'Items16';
export default Items16;
